//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.GeneralArrangement.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.GeneralArrangement.DrawingItemBuilderList.js";
import "../no/Features.js";
import "../no/ShipDesign.js";
import "../no/ObjectList.js";
let d=[[[1,"ViewList",0,"Features.ShipDesign.GeneralArrangement.DrawingItemBuilderList",0],[0,"ViewType",1,0]],[[[],"CreateDrawingViewItemBuilder",{R_:{drawingViewItemBuilder:"Features.ShipDesign.GeneralArrangement.DrawingViewItemBuilder"}},0,0],[[],"CreateDrawingTableItemBuilder",{R_:{drawingTableItemBuilder:"Features.ShipDesign.GeneralArrangement.DrawingTableItemBuilder"}},0,0],[["journal_identifier"],"Find",{R_:{found:"TaggedObject"}},1,0]],[]];
SPLM.Features.ShipDesign.GeneralArrangement.DrawingAutomationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.GeneralArrangement.DrawingAutomationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;